const KEY = 'guestAuth';

export function setGuestSession({ token, enrollment, classInfo }) {
    localStorage.setItem(KEY, JSON.stringify({ token, enrollment, classInfo }));
}

export function getGuestSession() {
    try {
        return JSON.parse(localStorage.getItem(KEY)) || null;
    } catch {
        return null;
    }
}

export function clearGuestSession() {
    localStorage.removeItem(KEY);
}

export function getGuestToken() {
    const s = getGuestSession();
    return s && s.token ? s.token : null;
}

export function isGuestLoggedIn() {
    return !!getGuestToken();
}
